/**
 * Fixed copy of the leader profile page (`./LeadershipProfile.tsx`), in English, French and
 * Spanish: only the credentials heading. The name, job title, media, biography and credentials
 * come from the Contentful `leader` entry.
 */
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { LeadershipProfileSetup } from "./LeadershipProfile";

/** The credentials heading per language, read by `./LeadershipProfile.tsx`. */
export const LeadershipProfileSetupLanguage: LanguageContent<LeadershipProfileSetup> = {
	en: {
		experienceLabel: "Experience and Area of Expertise",
	},
	fr: {
		experienceLabel: "Expérience et domaine d'expertise",
	},
	es: {
		experienceLabel: "Experiencia y área de especialización",
	},
};
